import {useCallback} from 'react'
import {useFieldContext} from '../../integrations/form/index.js'

/**
 * Shared hook for Select-like components that handle single or multi-value selection.
 * Encapsulates field context, value normalization, and change handling.
 */
export function useSelectField() {
  const field = useFieldContext<string[] | string>()

  const isSingleMode = 'mode' in field.options && field.options.mode === 'value'

  let value: string[] = []
  if (field.state.value) {
    value = Array.isArray(field.state.value) ? field.state.value : [field.state.value]
  }

  const handleChange = useCallback(
    (newValue: string[]) => {
      if (isSingleMode) {
        field.handleChange(newValue?.[0] ?? '')
      } else {
        field.handleChange(newValue)
      }
    },
    [field.handleChange]
  )

  return {
    field,
    value,
    handleChange,
    isSingleMode,
  }
}
